<template>
  <div class="container-fluid">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Product Summary</h6>
      </div>
      <div class="card-body text-align-left" v-if="productData">
        <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <p class="col-6 no-margin">
                  ID:
                </p>
                <p class="col-6 no-margin">
                  {{productData.product.ID}}<br>
                </p>
                <p class="col-6 no-margin">
                  Product:
                </p>
                <p class="col-6 no-margin">
                  {{productData.product.Product}}<br>
                </p>
                <p class="col-6 no-margin" v-if="marketplace==='channeladvisor'">
                  Short Description:
                </p>
                <p class="col-6 no-margin" v-if="marketplace==='channeladvisor'">
                  {{productData.product.ShortDescription}}<br>
                </p>
                <p class="col-6 no-margin">
                  Amount:
                </p>
                <p class="col-6 no-margin">
                  {{productData.product.Amount}}<br>
                </p>
                <p class="col-6 no-margin">
                  Condition:
                </p>
                <p class="col-6 no-margin">
                  {{productData.product.Condition}}<br>
                </p>
                <p class="col-6 no-margin">
                  SKU:
                </p>
                <p class="col-6 no-margin">
                  {{productData.product.SKU}}<br>
                </p>
            </div>
            <br>
            <br>
            <h5> Prices </h5>
            <div class="row" v-if="marketplace=='amazon'">
              <p class="col-6 no-margin">
                  Prices Total:
              </p>
              <p class="col-6 no-margin">
                  {{productData.product.Prices.Total}}<br>
              </p><br><br>
            </div>
            <div v-else class="row">
              <p class="col-6 no-margin">
                  Buy it Now:
              </p>
              <p class="col-6 no-margin">
                  {{productData.product.Prices.BuyItNow}}<br>
              </p>
              <p class="col-6 no-margin">
                  Reserve:
              </p>
              <p class="col-6 no-margin">
                  {{productData.product.Prices.Reserve}}<br>
              </p>
              <p class="col-6 no-margin">
                  Retail:
              </p>
              <p class="col-6 no-margin">
                  {{productData.product.Prices.Retail}}<br>
              </p>
              <p class="col-6 no-margin">
                  Second Chance:
              </p>
              <p class="col-6 no-margin">
                  {{productData.product.Prices.SecondChance}}<br>
              </p>
              <p class="col-6 no-margin">
                  Starting:
              </p>
              <p class="col-6 no-margin">
                  {{productData.product.Prices.Starting}}<br>
              </p>
              <p class="col-6 no-margin">
                  Store:
              </p>
              <p class="col-6 no-margin">
                  {{productData.product.Prices.Store}}<br>
              </p>
              <br><br><br>
              <h6 class="col-12 no-margin" v-if="productData.product.BatteryCompatible"> Battery Compatible: </h6><br><br>
            </div>
            <div class="container">
              <div class="row" v-for="(type,index) in productData.product.BatteryCompatible" v-bind:key="index" >
                  <div class="col-12" style="font-weight: bold"> {{index}}: </div><br><br>
                  <div class="container">
                    <div class="row" v-for="(item, key) in type" v-bind:key="key">
                      <div class="col-6"> {{key}}: </div>
                      <div  v-for="(entry, j) in item" v-bind:key="j" v-bind:class="{ 'col-6': j == 0 , 'col-12': j!== 0, 'margin-half-left': j!==0 }">{{entry}}</div><br>
                    </div>
                  </div>
              </div>

              <div class="row" v-for="(type,index) in productData.product.PlugCompatible" v-bind:key="index" >
                  <div class="col-12" style="font-weight: bold"> {{index}}: </div><br><br>
                  <div class="container">
                    <div class="row" v-for="(item, key) in type" v-bind:key="key" >
                      <div class="col-6"> {{key}}: </div>
                      <div  v-for="(entry, j) in item" v-bind:key="j" v-bind:class="{ 'col-6': j == 0 , 'col-12': j!== 0, 'margin-half-left': j!==0 }">{{entry}}</div><br>
                    </div>
                  </div>
              </div>
            </div>
          </div>
          </div>
          </div>
      </div>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
//import bPagination from 'bootstrap-vue/esm/components/pagination/pagination';
//import {GridTable} from '@dmunoz/gridtable';
import ProductApiRequest from '@/components/ApiRequester/Product.js';
//import bTabs  from 'bootstrap-vue/esm/components/tabs/tabs';
//import bTab  from 'bootstrap-vue/esm/components/tabs/tab';

export default {
  name: 'home',
  components: {
    //'marketplaces-grid': GridTable,
    //'b-pagination': bPagination,
  },
    data() {
    return {
      productData: undefined,
      batteryCompatible: undefined,
      plugCompatible: undefined,
    }
  },
  computed: {

  },
  mounted() {

      this.marketplace = this.$route.params.marketplace.toLowerCase();
      document.getElementById('loader').classList.add('active');
      const productApiRequest = new ProductApiRequest();
      let payload = {
        id: this.$route.params.id,
        marketplace: this.$route.params.marketplace
      };
       productApiRequest.detail(payload).then((response) => {
          this.productData = response.data;

          console.log(this.productData);
          document.getElementById('loader').classList.remove('active');
       }).catch(() => {
         document.getElementById('loader').classList.remove('active');
       });
  },
  methods: {


  }
};
</script>

